import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ResumeOrStartPopupComponent } from 'src/app/core/components/layouts/resume-or-start-popup/resume-or-start-popup.component';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { LoadingService } from 'src/app/core/services/loader.service';
import { FinancialGoalService } from '../financial-goal/services/financial-goal.service';
import { ForgotPasswordComponent } from '../users/forgot-password/forgot-password.component';
import { LoginOtpComponent } from '../users/login-otp/login-otp.component';
import { LoginComponent } from '../users/login/login.component';
import { UsersService } from '../users/services/users.service';
import { WithdrawOpportunityPopupComponent } from '../users/withdraw-opportunity-popup/withdraw-opportunity-popup.component';

@Component({
  selector: 'app-start-application',
  templateUrl: './start-application.component.html',
  styleUrls: ['./start-application.component.scss'],
})
export class StartApplicationComponent implements OnInit {
  // userLogedIn= false;
  userName = 'Adam';
  allOpportunity;
  public token;
  userData;
  contactId: string;
  userFullName: string;
  accountId: string;
  nextUrl: string;
  currentStage: string;
  currentStageUrl: string;
  currentOpportunityID: string;
  currentSelectedLeadFor: number;
  currentOppName: string;
  startNewUrl: string;
  constructor(
    public auth: AuthenticationService,
    public dialog: MatDialog,
    private loadingService: LoadingService,
    private financialGoalService: FinancialGoalService,
    private route: ActivatedRoute,
    private userService: UsersService
  ) {}

  ngOnInit(): void {
    const user = this.auth.getLoginUserName();
    if (user) {
      this.userName = user;
    }
    if (this.auth.isLoggedIn) {
      this.auth.fetchingData.next('/');
    }
    const queryParameter = this.route.snapshot.queryParams;
    if (
      queryParameter?.userid &&
      queryParameter.userid.trim().length > 0 &&
      !this.auth.isLoggedIn
    ) {
      this.getUserByID(queryParameter.userid);
    }
  }
  getUserByID(id: string) {
    this.loadingService.startLoading();
    this.userService.getUserByID(id).subscribe(
      (responseValue) => {
        this.loadingService.stopLoading();
        if (responseValue && responseValue.data) {
          if (responseValue.data.passwordCreated) {
            this.openDialog(
              'LOGIN TO YOUR ACCOUNT',
              true,
              responseValue.data.emailaddress1
            );
          } else {
            this.auth.gotoUrl(
              `user/create-password/${responseValue.data.contactid}`,
              {
                oppid: this.route.snapshot.queryParams.oppid,
                email: responseValue.data.emailaddress1,
              }
            );
            this.auth.showSnackBarMsg(
              'You have not created password yet. please create your password.',
              9000
            );
            // this.router.navigate(
            //   [`user/update-password/${responseValue.data.contactid}`],
            //   {
            //     queryParams: {
            //       oppid: this.route.snapshot.queryParams.oppid,
            //     },
            //   }
            // );
          }
        }
      },
      (error) => {
        console.log(error);
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg(
          'Something Went Wrong,Please Try again after some time'
        );
      }
    );
  }
  applicationSelection(route: string) {
    if (this.auth.isLoggedIn) {
      this.token = this.auth.getUserAccessToken();
      this.contactId = this.auth.getPrimaryUserId();
      this.accountId = this.auth.getUserAccountId();
      this.userData = this.auth.getDecodedUserAccessToken();
      this.userFullName = this.userData.contactDetails[0].fullname;
      this.allOpportunity = this.auth.getAllOpportunity();
    }
    switch (route) {
      case '/debtapp': {
        if (this.auth.isLoggedIn) {
          const currentOpp = this.auth.getCurrentOpportunityId();

          this.nextUrl = '/financial-goal';
          if (currentOpp) {
            this.resumeOrStart(2);
          } else {
            this.redirectToURL('/debtapp');
          }
        } else {
          this.redirectToURL('/debtapp');
        }
        break;
      }
      case '/superannuation': {
        if (this.auth.isLoggedIn) {
          const currentOpp = this.auth.getCurrentSuperOpportunityId();
          this.nextUrl = '/superannuation';
          if (currentOpp) {
            this.resumeOrStart(1);
          } else {
            this.addNewOpportunity(1);
          }
        } else {
          this.redirectToURL('/superannuation');
        }
        break;
      }
      case '/managed-account': {
        if (this.auth.isLoggedIn) {
          const currentOpp = this.auth.getCurrentInvestmentOpportunityId();
          this.nextUrl = '/managed-account';
          if (currentOpp) {
            this.resumeOrStart(9);
          } else {
            this.addNewOpportunity(9);
          }
        } else {
          this.redirectToURL('/managed-account');
        }
        break;
      }
      case '/general-insurance': {
        if (this.auth.isLoggedIn) {
          const currentOpp =
            this.auth.getCurrentGeneralInsuranceOpportunityId();
          this.nextUrl = '/general-insurance';
          if (currentOpp) {
            this.resumeOrStart(4);
          } else {
            this.addNewOpportunity(4);
          }
        } else {
          this.redirectToURL('/general-insurance');
        }
        break;
      }
      case '/health-insurance': {
        if (this.auth.isLoggedIn) {
          const currentOpp = this.auth.getCurrentHealthInsuranceOpportunityId();
          this.nextUrl = '/health-insurance';
          if (currentOpp) {
            this.resumeOrStart(5);
          } else {
            this.addNewOpportunity(5);
          }
        } else {
          this.redirectToURL('/health-insurance');
        }
        break;
      }
      case '/estate-planning': {
        if (this.auth.isLoggedIn) {
          const currentOpp = this.auth.getCurrentEstatePlanningOpportunityId();
          this.nextUrl = '/estate-planning';
          if (currentOpp) {
            this.resumeOrStart(6);
          } else {
            this.addNewOpportunity(6);
          }
        } else {
          this.redirectToURL('/estate-planning');
        }
        break;
      }
      case '/financial-planning': {
        if (this.auth.isLoggedIn) {
          const currentOpp =
            this.auth.getCurrentFinancialPlanningOpportunityId();
          this.nextUrl = '/financial-planning';
          if (currentOpp) {
            this.resumeOrStart(7);
          } else {
            this.addNewOpportunity(7);
          }
        } else {
          this.redirectToURL('/financial-planning');
        }
        break;
      }
      case '/life-insurance': {
        if (this.auth.isLoggedIn) {
          const currentOpp = this.auth.getCurrentLifeInsuranceOpportunityId();
          this.nextUrl = '/life-insurance';
          if (currentOpp) {
            this.redirectToURL('/life-insurance');
          } else {
            this.addNewOpportunity(3);
          }
        } else {
          this.redirectToURL('/life-insurance');
        }
        break;
      }
      default: {
        this.redirectToURL('/');
        break;
      }
    }
  }

  redirectToURL(url = '') {
    // this.router.navigate([url]);
    // window.scroll(0, 0);
    this.auth.gotoUrl(url);
  }
  setAllData(leadFor: number) {
    const selectedOpp = this.allOpportunity.find((element) => {
      return element.tlx_leadfor == leadFor;
    });

    if (selectedOpp) {
      this.currentStage = selectedOpp._activestageid_value;
      this.currentOpportunityID = selectedOpp.opportunityid;
      this.currentSelectedLeadFor = leadFor;
      const opprtunityName = selectedOpp.name.split(' - ');
      this.currentOppName = opprtunityName[1];
      this.startNewUrl = this.nextUrl;
      if (leadFor == 2) {
        // debt
        this.currentStageUrl = this.auth.getDebtCurrentUrl(this.currentStage);
        this.currentOppName =
          this.auth.opportunityType[selectedOpp.tlx_debtneedstransactiontype];
      } else if (leadFor == 1) {
        // superannuation
        this.currentStageUrl = this.auth.getSuperCurrentUrl(this.currentStage);
      } else if (leadFor == 9) {
        // managed account
        this.currentStageUrl = this.auth.getmanagedInvestmentCurrentUrl(
          this.currentStage
        );
      } else if (leadFor == 4) {
        // general insurance
        this.currentStageUrl = this.auth.getGeneralInsuranceCurrentUrl(
          this.currentStage
        );
      } else if (leadFor == 5) {
        // health insurance
        this.currentStageUrl = this.auth.getHealthInsuranceCurrentUrl(
          this.currentStage
        );
      } else if (leadFor == 6) {
        // estate planning
        this.currentStageUrl = this.auth.getEstatePlanningCurrentUrl(
          this.currentStage
        );
      } else if (leadFor == 7) {
        // financial planning
        this.currentStageUrl = this.auth.getFinancialPlanningCurrentUrl(
          this.currentStage
        );
      } else if (leadFor == 3) {
        // health and personal insurance
        this.currentStageUrl = this.auth.getHealthInsuranceCurrentUrl(
          this.currentStage
        );
      }
    }
  }
  resumeOrStart(leadfor: number) {
    this.setAllData(leadfor);
    const dialogRef = this.dialog.open(ResumeOrStartPopupComponent, {
      width: '400px',
      data: {
        name: this.currentOppName,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'resume') {
          this.redirectToURL(this.currentStageUrl);
        } else {
          this.auth.showSnackBarMsg(
            `Please withdraw current ${this.currentOppName} application.`,
            9000
          );
          this.disableOpportunity(
            this.currentOpportunityID,
            this.currentSelectedLeadFor
          );
          // this.redirectToURL(this.startNewUrl);
        }
      }
    });
  }
  disableOpportunity(oppID: string, leadFor: number) {
    const dialogRef = this.dialog.open(WithdrawOpportunityPopupComponent, {
      width: '720px',
      position: { right: '0', bottom: '0' },
      data: { type: 'add', data: oppID, leadFor },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.leadFor == 2) {
          this.redirectToURL(this.startNewUrl);
        } else {
          this.addNewOpportunity(leadFor);
        }
      }
    });
  }
  addNewOpportunity(leadFor: number) {
    const formData = {
      userFullName: this.userFullName,
      contactId: this.contactId,
      accountID: this.accountId,
      leadFor,
    };
    let oppName: string;
    this.loadingService.startLoading();
    this.financialGoalService.saveFinancial(formData).subscribe(
      (response) => {
        this.loadingService.stopLoading();
        if (response) {
          let newopp = {};

          if (leadFor == 1) {
            this.auth.setCurrentSuperOpportunityId(response.data.opportunityid);
            oppName = 'Superannuation Application';
            newopp = {
              ...newopp,
              businessprocessflowinstanceid:
                response.data.businessprocessflowinstanceid,
              _activestageid_value: 'a11f4588-28ec-8a7a-86f4-1d06dd4200cb',
              _activestageid_value_Formatted: 'Confirm Needs',
            };
          }
          if (leadFor == 9) {
            this.auth.setCurrentInvestmentOpportunityId(
              response.data.opportunityid
            );
            oppName = 'Managed Investment Application';
            newopp = {
              ...newopp,
              businessprocessflowinstanceid:
                response.data.businessprocessflowinstanceid,
              _activestageid_value: '7a2e74cf-784e-4a40-a6d4-52a78cfaddb1',
              _activestageid_value_Formatted:
                'Confirm Investment Account Needs',
            };
          }
          if (leadFor == 4) {
            this.auth.setCurrentGeneralInsuranceOpportunityId(
              response.data.opportunityid
            );
            oppName = 'General Insurance Application';
            newopp = {
              ...newopp,
              businessprocessflowinstanceid:
                response.data.businessprocessflowinstanceid,
              _activestageid_value: '3d2d49c7-17f7-4e61-be92-7aec9d824fe9',
              _activestageid_value_Formatted: 'Confirm General Insurance Needs',
            };
          }
          if (leadFor == 5) {
            this.auth.setCurrentHealthInsuranceOpportunityId(
              response.data.opportunityid
            );
            oppName = 'Health Insurance Application';
            newopp = {
              ...newopp,
              businessprocessflowinstanceid:
                response.data.businessprocessflowinstanceid,
              _activestageid_value: 'dd7d0688-38bc-484f-b3b6-00d974c00b3d',
              _activestageid_value_Formatted: 'Confirm Health Insurance Needs',
            };
          }
          if (leadFor == 6) {
            this.auth.setCurrentEstatePlanningOpportunityId(
              response.data.opportunityid
            );
            oppName = 'Estate Planning Application';
            newopp = {
              ...newopp,
              businessprocessflowinstanceid:
                response.data.businessprocessflowinstanceid,
              _activestageid_value: '860c244b-9214-48f4-942e-267926726fdb',
              _activestageid_value_Formatted: 'Confirm Estate Planning Needs',
            };
          }

          if (leadFor == 7) {
            this.auth.setCurrentFinancialPlanningOpportunityId(
              response.data.opportunityid
            );
            oppName = 'Financial Planning Application';
            newopp = {
              ...newopp,
              businessprocessflowinstanceid:
                response.data.businessprocessflowinstanceid,
              _activestageid_value: '97f16148-4f74-4ead-887d-c3546a6e8cf9',
              _activestageid_value_Formatted:
                'Confirm Financial Planning Needs',
            };
          }
          if (leadFor == 3) {
            this.auth.setCurrentLifeInsuranceOpportunityId(
              response.data.opportunityid
            );
            oppName = 'Life and Personal Insurance Application';
          }
          newopp = {
            ...newopp,
            name: `${formData.userFullName} - ${oppName}`,
            opportunityid: response.data.opportunityid,
            _bpf_opportunityid_value: response.data.opportunityid,
            // _new_investmentaccount_value: response.data.investmentid,
            tlx_leadfor: leadFor,
          };
          const allOpportunity = this.auth.getAllOpportunity();
          const newData = [...allOpportunity, newopp];
          this.auth.setOpportunityinSession(newData);
          this.auth.updateSideBar();
          window.scroll(0, 0);
          this.redirectToURL(this.nextUrl);
          // const allOpportunity = this.auth.getAllOpportunity();
          // const newData = [
          //   ...allOpportunity,
          //   {
          //     _activestageid_value: 'ece3b3ec-e98a-4d95-8ce0-eff28d771b26',
          //     _activestageid_value_Formatted: 'Confirm Loan Needs',
          //     _bpf_opportunityid_value: response.data.opportunityid,
          //     tlx_debtneedstransactiontype:
          //       formData.tlx_debtneedstransactiontype,
          //   },
          // ];
          // this.auth.setOpportunityinSession(newData);
          // this.auth.updateSideBar();
        }
      },
      (error) => {
        console.log(error);
        this.loadingService.stopLoading();
        this.auth.showSnackBarMsg(error.error.message);
      }
    );
    // }
  }
  // getDebtCurrentStage(): string {
  //   const currentStage = this.allOpportunity[0]._activestageid_value;
  //   return this.auth.getDebtCurrentUrl(currentStage);
  // }

  openDialog(headline: string, disableEmail = false, email?: string) {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '500px',
      data: {
        headline,
        disableEmail,
        email,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'forgotPassword') {
          this.openForgotDialog();
        } else if (result == 'otpLogin') {
          this.loginOtp();
        } else if (result == 'onRegister') {
        }
      }
    });
  }
  loginOtp() {
    const dialogRef = this.dialog.open(LoginOtpComponent, {
      width: '500px',
      data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'backToLogin') {
          this.openDialog('LOGIN TO YOUR ACCOUNT');
        } else if (result == 'forgotPassword') {
          this.openForgotDialog();
        } else if (result == 'onRegister') {
        }
      }
    });
  }
  openForgotDialog() {
    const dialogRef = this.dialog.open(ForgotPasswordComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'backToLogin') {
          this.openDialog('LOGIN TO YOUR ACCOUNT');
        }
      }
    });
  }
}
